{
	"_comment": "This file is updated by the build process. Do not edit it manually.",
	"version": "1.72.0",
	"hash": "822c307f78ed318cc1791b3d671776c4a1d460fc"
}
